import React from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import CloseIcon from "@mui/icons-material/Close";

type AppUpdateCardProps = {
    visible: boolean;
    onReload: () => void;
    onDismiss: () => void;
};

const AppUpdateCard: React.FC<AppUpdateCardProps> = ({
    visible,
    onReload,
    onDismiss,
}) => {
    if (!visible) return null;

    return (
        <Box
            sx={{
                position: "fixed",
                left: "50%",
                bottom: 24,
                transform: "translateX(-50%)",
                zIndex: 1400,
                width: "min(calc(100vw - 24px), 520px)",
                backgroundColor: "#FFFFFF",
                border: "1px solid #EAEAEA",
                borderRadius: "12px",
                boxShadow: "0px 10px 30px rgba(15, 23, 42, 0.10)",
                px: 1.75,
                py: 1.25,
                display: "flex",
                alignItems: "center",
                gap: 1,
            }}
        >
            <Typography
                sx={{
                    flex: 1,
                    minWidth: 0,
                    fontSize: 13,
                    fontWeight: 500,
                    color: "#1A1A1A",
                    lineHeight: "20px",
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                }}
            >
                There&apos;s a new version of Libretto. Please reload the page.
            </Typography>

            <Button
                onClick={onReload}
                sx={{
                    minWidth: "auto",
                    px: 1,
                    py: 0.5,
                    borderRadius: "8px",
                    fontSize: 14,
                    fontWeight: 500,
                    textTransform: "none",
                    color: "#1A1A1A",
                    backgroundColor: "transparent",
                    "&:hover": {
                        backgroundColor: "#F5F5F5",
                    },
                }}
            >
                Reload
            </Button>

            <IconButton
                onClick={onDismiss}
                size="small"
                sx={{
                    color: "#1A1A1A",
                    width: 28,
                    height: 28,
                    "&:hover": {
                        backgroundColor: "#F5F5F5",
                    },
                }}
            >
                <CloseIcon sx={{ fontSize: 18 }} />
            </IconButton>
        </Box>
    );
};

export default AppUpdateCard;
